module.exports = __webpack_public_path__ + "img/hongbaoyu.14624f1d.png";